// Computes a human-readable inactivity label from the last login date.
// A user is considered inactive after 30+ days without login.
export function inactivity(lastLogin, createdAt) {
  const ts = lastLogin || null;
  if (!ts) {
    return { days: null, inactive: true, neverLoggedIn: true, label: "Jamais connecté", durText: "Jamais connecté" };
  }
  const days = Math.max(0, Math.floor((Date.now() - new Date(ts).getTime()) / 86400000));
  const inactive = days >= 30;
  let dur;
  if (days === 0) dur = "aujourd'hui";
  else if (days === 1) dur = "1 jour";
  else if (days < 60) dur = `${days} jours`;
  else {
    const m = Math.floor(days / 30);
    dur = m < 12 ? `${m} mois` : `${Math.floor(m / 12)} an(s)`;
  }
  const label = inactive ? `Inactif depuis ${dur}` : `Actif · il y a ${dur}`;
  const durText = inactive ? dur : `il y a ${dur}`;
  return { days, inactive, neverLoggedIn: false, label, durText };
}
